import React from 'react';
import BirdIcon from '../assets/Bird.svg?react';
import BatIcon from '../assets/Bat.svg?react';
import MammalsIcon from '../assets/Mammals.svg?react';
import OthersIcon from '../assets/others.svg?react';

/**
 * Get the appropriate icon component for a species ID
 * @param speciesId - The ID of the species ('birds', 'bats', 'mammals', 'others')
 * @returns The React component for the icon, or OthersIcon if not found
 */
export function getSpeciesIconComponent(speciesId: string): React.ComponentType<any> {
  switch (speciesId.toLowerCase()) {
    case 'birds':
    case 'bird':
      return BirdIcon;
    case 'bats':
    case 'bat':
      return BatIcon;
    case 'mammals':
    case 'mammal':
      return MammalsIcon;
    case 'others':
    case 'other':
    default:
      return OthersIcon;
  }
}

/**
 * Render a species icon as a JSX element
 * @param speciesId - The ID of the species
 * @param width - Width of the icon in pixels
 * @param height - Height of the icon in pixels
 * @param className - Optional CSS class
 * @returns JSX element
 */
export function renderSpeciesIcon(
  speciesId: string,
  width: number = 32,
  height: number = 32,
  className?: string
): React.ReactElement {
  const IconComponent = getSpeciesIconComponent(speciesId);

  return (
    <IconComponent
      width={width}
      height={height}
      className={className}
      style={{
        display: 'block',
      }}
    />
  );
}

/**
 * Render a species icon with white invert filter
 * @param speciesId - The ID of the species
 * @param width - Width of the icon in pixels
 * @param height - Height of the icon in pixels
 * @returns JSX element with invert filter
 */
export function renderSpeciesIconInverted(
  speciesId: string,
  width: number = 32,
  height: number = 32
): React.ReactElement {
  const IconComponent = getSpeciesIconComponent(speciesId);

  return (
    <IconComponent
      width={width}
      height={height}
      style={{
        filter: 'brightness(0) invert(1)',
        display: 'block',
      }}
    />
  );
}
